export default __webpack_public_path__ + "static/media/previewSite.845636cf.png";